import { LOADING_STATUS } from 'client/js/main/support/constants';
import { INIT_STATE } from 'client/js/redux/domains/EmailIngestor/EmailIngestor.constants';
import type { EmailIngestorState } from 'client/js/redux/domains/EmailIngestor/EmailIngestor.types';
import {
  type EmailIngestorAction,
  GET_EMAIL_INGESTOR_BY_ID,
  GET_INGESTORS,
  PATCH_EMAIL_INGESTOR,
  SETUP_EMAIL_INGESTOR,
} from 'client/js/redux/domains/EmailIngestor/actions';
import { ReduxAsyncActionsService } from 'client/js/redux/services/ReduxAsyncActions.service';
import type { WrappedReducer } from 'client/js/redux/types/ReduxAsyncActions.types';

const Handler = (
  state: WrappedReducer<EmailIngestorState>,
  action: EmailIngestorAction
): WrappedReducer<EmailIngestorState> => {
  switch (action.type) {
    case GET_INGESTORS.response:
      return {
        ...state,
        data: action.data.data,
        pagination: action.data.pagination,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    case SETUP_EMAIL_INGESTOR.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    case PATCH_EMAIL_INGESTOR.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    case GET_EMAIL_INGESTOR_BY_ID.response:
      return {
        ...state,
        data: [action.data.data],
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    default:
      return state;
  }
};

const EmailIngestorReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, Handler, {
  request: [GET_INGESTORS, SETUP_EMAIL_INGESTOR, GET_EMAIL_INGESTOR_BY_ID, PATCH_EMAIL_INGESTOR],
  error: [GET_INGESTORS, SETUP_EMAIL_INGESTOR, GET_EMAIL_INGESTOR_BY_ID, PATCH_EMAIL_INGESTOR],
});

export default EmailIngestorReducer;
